import { render, staticRenderFns } from "./JsonDrawer.vue?vue&type=template&id=246d2d4b&scoped=true"
import script from "./JsonDrawer.vue?vue&type=script&lang=js"
export * from "./JsonDrawer.vue?vue&type=script&lang=js"
import style0 from "./JsonDrawer.vue?vue&type=style&index=0&id=246d2d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d2d4b",
  null
  
)

export default component.exports